import {
    VIDEO_DEFAULT_CAMERA_ID,
    VIDEO_DEFAULT_CAMERA_TITLE,
    VIDEO_DEFAULT_MIC_ID,
    VIDEO_DEFAULT_MIC_TITLE,
    VIDEO_DEFAULT_SPEAKER_ID,
    VIDEO_DEFAULT_SPEAKER_TITLE,
} from '@/constants/constants';
import {VideoSystemDevices} from '@/types/video';
import {vidyoProviderLogs} from '@/utils/general';

const storageDevicesMapper = {
    camera: {
        id: VIDEO_DEFAULT_CAMERA_ID,
        title: VIDEO_DEFAULT_CAMERA_TITLE,
        setDevice: async (device: any) => {
            vidyoProviderLogs({message: `Selecting camera: ${device.name} (${device.id})`, eventType: 'device'});
            await window.vidyoConnector.SelectLocalCamera({
                localCamera: device,
            });
        },
    },
    microphone: {
        id: VIDEO_DEFAULT_MIC_ID,
        title: VIDEO_DEFAULT_MIC_TITLE,
        setDevice: async (device: any) => {
            vidyoProviderLogs({message: `Selecting microphone: ${device.name} (${device.id})`, eventType: 'device'});
            await window.vidyoConnector.SelectLocalMicrophone({
                localMicrophone: device,
            });
        },
    },
    speaker: {
        id: VIDEO_DEFAULT_SPEAKER_ID,
        title: VIDEO_DEFAULT_SPEAKER_TITLE,
        setDevice: async (device: any) => {
            vidyoProviderLogs({message: `Selecting speaker: ${device.name} (${device.id})`, eventType: 'device'});
            await window.vidyoConnector.SelectLocalSpeaker({
                localSpeaker: device,
            });
        },
    },
};

const selectAnyNonIntegratedDevice = (deviceName: VideoSystemDevices) => {
    if (!window[deviceName]) {
        vidyoProviderLogs({message: `No ${deviceName} devices found`, eventType: 'device', status: 'error'});
        return;
    }

    const deviceCtrl = storageDevicesMapper[deviceName];

    const anyNonIntegratedDevice = window?.[deviceName]?.find((cam: any) => !cam.name.match(/integrated/i));
    if (anyNonIntegratedDevice) {
        vidyoProviderLogs({
            message: `Found non-integrated ${deviceName}: ${anyNonIntegratedDevice.name} (${anyNonIntegratedDevice.id})`,
            eventType: 'device',
        });
        deviceCtrl.setDevice(anyNonIntegratedDevice);
    }
};

export const loadPrevSelectedDevice = (deviceName: VideoSystemDevices) => {
    if (!window[deviceName]) {
        vidyoProviderLogs({message: `No ${deviceName} devices found`, eventType: 'device', status: 'error'});
        return;
    }

    const deviceCtrl = storageDevicesMapper[deviceName];

    const savedDeviceId = localStorage.getItem(deviceCtrl.id);
    const savedDeviceTitle = localStorage.getItem(deviceCtrl.title);

    if (savedDeviceId || savedDeviceTitle) {
        savedDeviceId &&
            vidyoProviderLogs({message: `Found default ${deviceName} ID: ${savedDeviceId}`, eventType: 'device'});

        savedDeviceTitle &&
            vidyoProviderLogs({message: `Found default ${deviceName} title: ${savedDeviceTitle}`, eventType: 'device'});
        const savedDevice = window?.[deviceName]?.find(
            (cam: any) => cam.id === savedDeviceId || cam.name.match(savedDeviceTitle),
        );
        if (savedDevice) {
            deviceCtrl.setDevice(savedDevice);
        } else {
            selectAnyNonIntegratedDevice(deviceName);
        }
    } else {
        vidyoProviderLogs({message: `No saved ${deviceName} found`, eventType: 'device'});
        selectAnyNonIntegratedDevice(deviceName);
    }
};
